

















































































































































































































































































































































































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Search } from '@/data/models/search.model';
import { Actor } from '@/data/models/actor.model';
import { Veicolo } from '@/data/models/veicolo.model';
import { ServiceInstance } from '@/data/models/serviceinstance.model';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import { Page } from '@/data/models/page.model';
import { currencyToNumber, numberMask } from '@/data/utils/helper';
import { Contatto } from '@/data/models/contatto.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class ServizioDatiServizio extends Vue {
	@Prop() serviceinstance!: ServiceInstance;
	@Prop() editable!: boolean;
	@Prop() hqid!: number;

	@Inject('CrudService') crudService!: CrudService<Tipologiaintervento>;

	actorClass: ClassType<Actor> = Actor;
	actorSearch: Search = new Search('actor');
	operatoreClass: ClassType<Actor> = Actor;
	operatoreSearch: Search = new Search('actor');
	veicoloClass: ClassType<Veicolo> = Veicolo;
	veicoloSearch: Search = new Search('vehicle');
	payerClass: ClassType<Actor> = Actor;
	payerSearch: Search = new Search('actor');
	interventoClass: ClassType<Tipologiaintervento> = Tipologiaintervento;

	paymentFreqs!: any[];

	tipologieIntervento: Tipologiaintervento[] = [];

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.actorSearch.addNotEqualFilter('patientid', null);
		this.actorSearch.addSimpleFilter('hqid', this.hqid);
		this.payerSearch.addSimpleFilter('hqid', this.hqid);
		this.veicoloSearch.addSimpleFilter('hqid', this.hqid);
		this.operatoreSearch.addSimpleFilter('hqid', this.hqid);
		this.operatoreSearch.addSimpleFilter('candrive', 1);
		this.operatoreSearch.addNotEqualFilter('volunteerid', null);
	}

	created() {
		if (this.serviceinstance.id) {
			const search = new Search('intervento');
			search.addSimpleFilter('name', this.serviceinstance.servicetype!);
			this.crudService.searchEntities(Tipologiaintervento, 'intervento', search, new Page())
				.then(result => {
					this.serviceinstance.servicetypemodel = result[0];
					if (this.$refs['servicetypemodel'] && this.serviceinstance['servicetypemodel']) {
						// @ts-ignore
						this.$refs['servicetypemodel'].autocomplete.setSelected(this.serviceinstance['servicetypemodel']);
					}
				})
				.catch(error => {
					this.$buefy.notification.open({
						message: error.msg,
						type: 'is-danger'
					});
				});
		}
	}

	mounted() {
		const refsList: string[] = [
			'patient',
			'driver', 
			'vehicle', 
			'payer', 
			'seconddriver',
		];
		for (const r of refsList) {
			// @ts-ignore
			if (this.$refs[r] && this.serviceinstance[r]) {
				// @ts-ignore
				this.$refs[r].autocomplete.setSelected(this.serviceinstance[r]);
			}
		}
	}

	onAddPatientAddress(key: string) {
		// set pickup/dropoff to patient address
		// @ts-ignore
		this.$set(this.serviceinstance, key, this.serviceinstance.patient?.fullAddress);
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		this.serviceinstance.ritornodate?.setDate(this.serviceinstance.startdate!.getDate());
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.serviceinstance, k, this.currencies[k]);
		});
		this.$emit('submit');
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.address ? contact.address : ''} ${contact.streetno ? contact.streetno : ''}`;
		}
	}

	operatoreFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	}

}
